import { useMutation } from '@northladder/services';
import {
  ErrorEventsEnum,
  errorLogToRemoteUtil,
  IApiError,
} from '@northladder/utilities';

import { USER_ACCOUNTS_API } from '../userAccountsAPIClient';

/**
 * This is to track the reset password mutation keys in react query cache.
 */
const MUT_USER_RESET_PASSWORD = 'user-reset-password';

interface ISendUserLoginOTPOptions {
  onSuccessCallback: () => void;
}

/**
 * This performs a password reset request. It takes the user entered otp
 * and the new password.
 */
export const useResetPasswordMutation = ({
  onSuccessCallback,
}: ISendUserLoginOTPOptions) => {
  const { mutate, isPending, error } = useMutation({
    mutationKey: [MUT_USER_RESET_PASSWORD],
    networkMode: 'always',
    retry: false,
    mutationFn: USER_ACCOUNTS_API.resetPassword,
    onSuccess: onSuccessCallback,
    onError: (err: IApiError) => {
      errorLogToRemoteUtil({
        error,
        errorCode: ErrorEventsEnum.ERROR_IN_API_CALL,
        errorTitle: 'Error in reset password attempt',
        message: err.message,
      });

      return err;
    },
  });

  return {
    error,
    isPending,
    resetPassword: mutate,
  };
};
